<template>
   <div class="menu-item" :class="{'bold': bold}" @click="onPath">
        <div class="menu-text">{{title}}</div>
        <div class="menu-icon">
            <i :class="iconImg"></i>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MenuComponent',
  props: {
     title:{
       types: String,
       required: true
     },
     icon: {
       types: String,
       default: "right"
     },
     bold: {
        types: Boolean,
        default: false
     },
     path: {
        types: String,
     },
     id: {
        types: Number,
     }
   },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
    iconImg () {
        let icon = 'el-icon-arrow-right'
        if (this.icon !== 'right') {
            icon = 'el-icon-arrow-up'
        }
        return icon
    }
  },
  methods: {
    onPath () {
        if (this.path) {
            if (this.id) {
              this.$router.push({name: this.path, query: {id: this.id}})
            } else {
              this.$router.push({name: this.path})
            }
        }
    }
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
.bold {
    font-weight: bold;
}
.menu-item {
    height: 60px;
    line-height: 60px;
    border-bottom: solid 1px #DFDFDF;
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
</style>
